module.exports = __webpack_public_path__ + "img/WhatsApp Image 2019-11-21 at 4.31.21 PM (2).649dabb7.jpeg";